import * as React from 'react';
import * as IoC from 'typescript-ioc';
import classnames from 'classnames';
import * as mobxReact from 'mobx-react';
import './event-tracker-list-group-header.scss';
import { DateTimeFormatter } from '../../../../infrastructure/implementations/date-formatter';
import { DateFnsFormats } from '../../../../infrastructure/date-formatter';
import { getIsSafariBrowser, isItemLocalDatesEquals } from '../../../../infrastructure/utils/common.utils';
import { GroupCollapseIcon } from '../../../global/group-collapse-icon/group-collapse-icon';
import { IntlShape } from 'react-intl';


const dateTimeFormatter = IoC.Container.get<DateTimeFormatter>(DateTimeFormatter);

const EventTrackerListGroupHeader = mobxReact.observer((props: {
    mergedDateTime: Date;
    colSpan: number;
    isCollapsed?: boolean;
    onCollapseToggle?: () => void;
    isAllMeetingsCollapsed?: boolean;
    itemsLength: number;
    intl: IntlShape;
}) => {
    const {
        mergedDateTime,
        colSpan,
        isCollapsed,
        isAllMeetingsCollapsed,
        onCollapseToggle,
        itemsLength,
        intl
    } = props;

    const localDayString = dateTimeFormatter.dateToFormattedString(
        mergedDateTime,
        DateFnsFormats.StringifiedFullDayMonthNumericDateYear,
    );

    const isSafari = getIsSafariBrowser();
    const isToday = isItemLocalDatesEquals({ startDateTime: mergedDateTime }, { startDateTime: new Date() });

    return (
        <tr className='event-tracker-list-group-header' onClick={onCollapseToggle}>
            <th colSpan={colSpan} className={classnames('single-row-title-cell date-cell',
                { 'single-row-title-cell--safari-browser': isSafari },
                { 'single-row-title-cell--today': isToday }
                )}
            >
                <GroupCollapseIcon isCollapsed={isCollapsed} isAllItemsCollapsed={isAllMeetingsCollapsed} />
                <div className='event-tracker-list-group-header__content'>
                    <span className='table-list-layout__inline-title'>{localDayString}</span>
                    <span className='event-tracker-list-group-header__count'>{itemsLength} {intl.formatMessage({
                        id: `oe.eventTracker.event${itemsLength > 1 ? 's' : ''}`,
                        defaultMessage: `Event${itemsLength > 1 ? 's' : ''}`,
                        description: 'Label text'
                    })}</span>
                    { isToday && <span className='event-tracker-list-group-header__today'>Today</span> }
                </div>
            </th>
        </tr>
    );
});

export { EventTrackerListGroupHeader };
